<template>
  <!-- 直播页面 -->

  <div>
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <Search />
            <div class="lives">
              <!-- 直播列表 -->
              <div
                class="info"
                v-infinite-scroll="loadMore"
                infinite-scroll-distance="100"
                infinite-scroll-disabled="busy"
                infinite-scroll-immediate-check="true"
              >
                <live-info-item
                  v-for="(item, index) in dataForm.liveList"
                  :key="index"
                  :liveStatus="item.liveStatus + ''"
                  :liveCoverImg="item.liveCoverImg"
                  :liveAmt="item.liveAmt"
                  :liveLecturers="item.liveLecturers"
                  :liveName="item.liveName"
                  :liveId="item.liveId"
                  :livePay="item.livePay"
                  :liveStartTime="item.liveStartTime"
                  :liveEndTime="item.liveEndTime"
                  :liveAttr="item.liveAttr"
                ></live-info-item>
                <!-- <div class="noCourse" v-show="dataForm.liveList.length <= 0">
                  暂无相关直播，敬请期待！
                </div> -->
                <div
                  v-if="pageIndex < dataForm.totalPage"
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                  @click="loadMore"
                >
                  点击加载更多...
                </div>
                <div
                  v-else
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                >
                  暂无更多直播...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import MtTabbar from '../../components/Tabbar'
import LiveInfoItem from '../../components/live/LiveInfoItem'
import Search from '../../components/Search'
export default {
  components: { Search, MtTabbar, LiveInfoItem },
  data() {
    return {
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
      busy: false,
    }
  },
  methods: {
    refresh() {
      location.reload()
    },

    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList()
      }
    },
    getLiveList() {
      this.$http({
        url: '/live/live/queryPayList/',
        method: 'get',
        params: {
          livePay: 0,
          liveStatus: 0,
          pageNo: this.pageIndex,
          pageSize: 10,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = this.dataForm.liveList.concat(
            data.data.records
          )
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalPage = data.data.pages
          this.dataForm.currPage = data.data.current
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
    },
  },
  mounted() {
    this.getLiveList()
  },
}
</script>

<style lang='scss' scoped>
.mint-navbar .mint-tab-item {
  padding-top: 5px;
}
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
.lives {
  padding: 0 1rem;
  p {
    margin: 2rem 0;
    padding: 2rem 0;
    font-size: $font-title;
    border-bottom: 3px solid $theme-color;
  }
}
.info {
  margin-bottom: 6rem;
}
</style>
